import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}
export async function getPackableAppointments(params = {}) {
  const res = await axios.get(`${API_BASE}/dispatch/appointments`, { headers: authHeader(), params });
  return res.data;
}
export async function getPackAssignedAppointments(params = {}) {
  const res = await axios.get(`${API_BASE}/dispatch/pack-assigned-appointments`, { headers: authHeader(), params });
  return res.data;
}
export async function getInventoryForAppointment(appointmentId, filters = {}) {
  // filters: { sizes: [...], genders: [...] } — serialize arrays as repeated
  // params (sizes=a&sizes=b) so FastAPI List[str] = Query parses them.
  const res = await axios.get(`${API_BASE}/dispatch/inventory-for-appointment/${appointmentId}`, {
    headers: authHeader(),
    params: filters,
    paramsSerializer: (params) => {
      const sp = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (Array.isArray(v)) v.forEach((x) => sp.append(k, x));
        else if (v != null) sp.append(k, v);
      });
      return sp.toString();
    },
  });
  return res.data;
}
export async function getPackItems(appointmentId) {
  const res = await axios.get(
    `${API_BASE}/dispatch/pack-items/${appointmentId}`,
    { headers: authHeader() }
  );
  return res.data;
}
export async function getSeenSkusForAppointment(appointmentId) {
  const res = await axios.get(
    `${API_BASE}/dispatch/seen-skus-for-appointment/${appointmentId}`,
    { headers: authHeader() }
  );
  return res.data;
}
export async function lookupItemByBarcodeForPack(barcode, appointmentId = null) {
  const res = await axios.get(
    `${API_BASE}/dispatch/lookup-item-by-barcode/${encodeURIComponent(barcode)}`,
    { headers: authHeader(), params: appointmentId ? { appointment_id: appointmentId } : undefined }
  );
  return res.data;
}
export async function createPack(appointmentId, itemIds, packRating = null) {
  const res = await axios.post(`${API_BASE}/dispatch/create-pack`, {
    appointment_id: appointmentId, item_ids: itemIds, pack_rating: packRating
  }, { headers: authHeader() });
  return res.data;
}
export async function cancelPack(packId) {
  const res = await axios.post(`${API_BASE}/dispatch/cancel-pack/${packId}`, {}, { headers: authHeader() });
  return res.data;
}
export async function updatePackItems(packId, itemIds) {
  const res = await axios.post(`${API_BASE}/dispatch/update-pack-items/${packId}`, {
    item_ids: itemIds
  }, { headers: authHeader() });
  return res.data;
}
export async function markDispatched(packId, eta) {
  const res = await axios.post(`${API_BASE}/dispatch/mark-dispatched/${packId}`, eta ? { eta } : {}, { headers: authHeader() });
  return res.data;
}
export async function getDispatchedAppointments() {
  const res = await axios.get(`${API_BASE}/dispatch/dispatched-appointments`, { headers: authHeader() });
  return res.data;
}
export async function getSetsInPack(packId) {
  const res = await axios.get(`${API_BASE}/sets/in-pack/${packId}`, { headers: authHeader() });
  return res.data;
}
async function _downloadBlob(url, filename) {
  const res = await axios.get(url, { headers: authHeader(), responseType: 'blob' });
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = blobUrl; a.download = filename; a.click();
  URL.revokeObjectURL(blobUrl);
}
export async function downloadComicGift(appointmentId, uid) {
  const base = `${API_BASE}/dispatch/comic-gift/${appointmentId}`;
  const label = uid || appointmentId;
  await _downloadBlob(`${base}/cover`, `${label}_comic_cover.jpg`);
  await _downloadBlob(`${base}/story`, `${label}_comic_story.jpg`);
}
export async function startReversal(appointmentId) {
  const res = await axios.post(`${API_BASE}/dispatch/start-reversal/${appointmentId}`, {}, { headers: authHeader() });
  return res.data;
}
export async function reversalCountCheck(appointmentId, count) {
  const res = await axios.post(`${API_BASE}/dispatch/reversal-count-check/${appointmentId}`,
    { appointment_id: appointmentId, count }, { headers: authHeader() });
  return res.data;
}
export async function reversalAccept(appointmentId, packerId) {
  const res = await axios.post(`${API_BASE}/dispatch/reversal-accept/${appointmentId}`,
    { packer_id: packerId }, { headers: authHeader() });
  return res.data;
}
export async function reversalScan(appointmentId, barcodes) {
  const res = await axios.post(`${API_BASE}/dispatch/reversal-scan/${appointmentId}`,
    { appointment_id: appointmentId, barcodes }, { headers: authHeader() });
  return res.data;
}
export async function reversalEscalate(appointmentId, missingBarcodes, commentary) {
  const res = await axios.post(`${API_BASE}/dispatch/reversal-escalate/${appointmentId}`, {
    appointment_id: appointmentId, missing_barcodes: missingBarcodes, commentary
  }, { headers: authHeader() });
  return res.data;
}
export async function startAdminReversal(appointmentId) {
  const res = await axios.post(`${API_BASE}/dispatch/start-admin-reversal/${appointmentId}`, {}, { headers: authHeader() });
  return res.data;
}
export async function adminReversalComplete(appointmentId, missingBarcodes, commentary, packerId) {
  const res = await axios.post(`${API_BASE}/dispatch/admin-reversal-complete/${appointmentId}`, {
    appointment_id: appointmentId, missing_barcodes: missingBarcodes, commentary, packer_id: packerId
  }, { headers: authHeader() });
  return res.data;
}
export async function getReversedItems(search = '', packerId = '') {
  const params = {};
  if (search) params.search = search;
  if (packerId) params.packer_id = packerId;
  const res = await axios.get(`${API_BASE}/dispatch/reversed-items`, { headers: authHeader(), params });
  return res.data;
}
export async function getPackers() {
  const res = await axios.get(`${API_BASE}/staff/packers`, { headers: authHeader() });
  return res.data;
}
export async function conditionCheck(itemId, action, binId = null) {
  const res = await axios.post(`${API_BASE}/dispatch/condition-check`, {
    item_id: itemId, action, bin_id: binId
  }, { headers: authHeader() });
  return res.data;
}
export async function restockAll() {
  const res = await axios.post(`${API_BASE}/dispatch/restock-all`, {}, { headers: authHeader() });
  return res.data;
}
export async function suggestPack(appointmentId, appointmentChildId) {
  const res = await axios.post(`${API_BASE}/dispatch/suggest-pack/${appointmentId}`, {
    appointment_child_id: appointmentChildId
  }, { headers: authHeader() });
  return res.data;
}
export async function getIroningItems(search = '') {
  const res = await axios.get(`${API_BASE}/dispatch/ironing-items`, {
    headers: authHeader(), params: search ? { search } : {}
  });
  return res.data;
}
export async function ironingClear(itemId, binId) {
  const res = await axios.post(`${API_BASE}/dispatch/ironing-clear`, {
    item_id: itemId, bin_id: binId
  }, { headers: authHeader() });
  return res.data;
}
export async function getMobileReversalAppointments() {
  const res = await axios.get(`${API_BASE}/dispatch/mobile-reversal/appointments`, { headers: authHeader() });
  return res.data;
}
export async function mobileReversalAttempt(appointmentId, count) {
  const res = await axios.post(`${API_BASE}/dispatch/mobile-reversal/${appointmentId}`,
    { count }, { headers: authHeader() });
  return res.data;
}
